import Vue from 'vue'
import Router from 'vue-router'


// 人事管理
// const broadcastclass = () => import("@/components/busi_renshi/broadcast_class");
// const broadcast = () => import("@/components/busi_renshi/broadcast");
// const broadcastpass = () => import("@/components/busi_renshi/broadcast_pass");


const person_data = () => import("@/components/busi_renshi/person_data"); //花名册
const user_record = () => import("@/components/busi_renshi/user_record"); //打卡记录查询

const recorddepbuild = () => import("@/components/busi_renshi/record_dep_build");
const recorddepmonth = () => import("@/components/busi_renshi/record_dep_month");
const recordclass = () => import("@/components/busi_renshi/record_class");
const recorduserpass = () => import("@/components/busi_renshi/record_user_pass");
const recordleve = () => import("@/components/busi_renshi/record_leve");
const recordpass = () => import("@/components/busi_renshi/record_pass");
const recordtransf = () => import("@/components/busi_renshi/record_transf");
const salarybase = () => import("@/components/busi_renshi/salary_base");
const salarypay = () => import("@/components/busi_renshi/salary_pay");
const salaryall = () => import("@/components/busi_renshi/salary_all");
const recordend = () => import("@/components/busi_renshi/record_end");
const salaryapply = () => import("@/components/busi_renshi/salary_apply");
const salaryhistory = () => import("@/components/busi_renshi/salary_history");
const salarypass = () => import("@/components/busi_renshi/salary_pass");
const salaryother = () => import("@/components/busi_renshi/salary_other");


const usersalarypay = () => import("@/components/busi_renshi/salary_allpay");
const setholidays = () => import("@/components/busi_renshi/set_holidays");
const advance = () => import("@/components/busi_renshi/salary_advance");

const advanceuse = () => import("@/components/busi_renshi/advanceuse");	//预支绑定使用
const salarypartpay = () => import("@/components/busi_renshi/salarypartpay"); //部分扣款
const userlost = () => import("@/components/busi_renshi/userlost");		//个人违规扣款
const salaryallsum = () => import("@/components/busi_renshi/salary_allsum");



Vue.use(Router)

export default[
	{
		name: "persondata",
		path: "/person_data",
		component: person_data,
		meta: {
			requiresAuth: true,
			keepAlive: true, // 不需要被缓存
			title: "用户私人信息"
		}
	},
	{
		name: "control_record",
		path: "/control_record",
		component: user_record,
		meta: {
			requiresAuth: true,
			keepAlive: true, // 不需要被缓存
			title: "员工打卡记录"
		}
	},
	{
		name: "recorddepbuild",
		path: "/recorddepbuild",
		component: recorddepbuild,
		meta: {
			requiresAuth: true,
			keepAlive: true, // 不需要被缓存
			title: "部门考勤模板建立"
		}
	},
	{
		name: "recorddepmonth",
		path: "/recorddepmonth",
		component: recorddepmonth,
		meta: {
			requiresAuth: true,
			keepAlive: true, // 不需要被缓存
			title: "每月部门考勤模板"
		}
	},
	{
		name: "recordclass",
		path: "/recordclass",
		component: recordclass,
		meta: {
			requiresAuth: true,
			keepAlive: true, // 不需要被缓存
			title: "人员考勤状态"
		}
	},
	{
		name: "recorduserpass",
		path: "/recorduserpass",
		component: recorduserpass,
		meta: {
			requiresAuth: true,
			keepAlive: true, // 不需要被缓存
			title: "人员考勤审核"
		}
	},
	{
		name: "recordleve",
		path: "/recordleve",
		component: recordleve,
		meta: {
			requiresAuth: true,
			keepAlive: true, // 不需要被缓存
			title: "请假单申请"
		}
	},
	{
		name: "recordtransf",
		path: "/recordtransf",
		component: recordtransf,
		meta: {
			requiresAuth: true,
			keepAlive: true, // 不需要被缓存
			title: "调休单申请"
		}
	},
	{
		name: "salarybase",
		path: "/salarybase",
		component: salarybase,
		meta: {
			requiresAuth: true,
			keepAlive: true, // 不需要被缓存
			title: "基本工资"
		}
	},
	{
		name: "salarypay",
		path: "/salarypay",
		component: salarypay,
		meta: {
			requiresAuth: true,
			keepAlive: true, // 不需要被缓存
			title: "工资抵扣"
		}
	},
	{
		name: "recordend",
		path: "/recordend",
		component: recordend,
		meta: {
			requiresAuth: true,
			keepAlive: true, // 不需要被缓存
			title: "考勤结果"
		}
	},
	{
		name: "salaryapply",
		path: "/salaryapply",
		component: salaryapply,
		meta: {
			requiresAuth: true,
			keepAlive: true, // 不需要被缓存
			title: "调薪申请"
		}
	},
	{
		name: "salaryhistory",
		path: "/salaryhistory",
		component: salaryhistory,
		meta: {
			requiresAuth: true,
			keepAlive: true, // 不需要被缓存
			title: "调薪初审"
		}
	},
	{
		name: "salarypass",
		path: "/salarypass",
		component: salarypass,
		meta: {
			requiresAuth: true,
			keepAlive: true, // 不需要被缓存
			title: "业务终审"
		}
	},
	{
		name: "salaryother",
		path: "/salaryother",
		component: salaryother,
		meta: {
			requiresAuth: true,
			keepAlive: true, // 不需要被缓存
			title: "个人工资其他单"
		}
	},
	{
		name: "usersalarypay",
		path: "/usersalarypay",
		component: usersalarypay,
		meta: {
			requiresAuth: true,
			keepAlive: true, // 不需要被缓存
			title: "工资发放"
		}
	},
	{
		name: "setholidays",
		path: "/setholidays",
		component: setholidays,
		meta: {
			requiresAuth: true,
			keepAlive: true, // 不需要被缓存
			title: "节假日管理"
		}
	},
	{
		name: "advance",
		path: "/advance",
		component: advance,
		meta: {
			requiresAuth: true,
			keepAlive: true, // 不需要被缓存
			title: "工资预支申请"
		}
	},
	{
		name: "salaryall",
		path: "/salaryall",
		component: salaryall,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "工资单"
		}
	},
	{
		name: "recordpass",
		path: "/recordpass",
		component: recordpass,
		meta: {
			requiresAuth: true,
			keepAlive: true, // 不需要被缓存
			title: "请假调休审核"
		}
	},
	{
		name: "advanceuse",
		path: "/advanceuse",
		component: advanceuse,
		meta: {
			requiresAuth: true,
			keepAlive: true, // 不需要被缓存
			title: "预支绑定使用"
		}
	},
	{
		name: "salarypartpay",
		path: "/salarypartpay",
		component: salarypartpay,
		meta: {
			requiresAuth: true,
			keepAlive: true, // 不需要被缓存
			title: "部分发放工资"
		}
	},
	{
		name: "userlost",
		path: "/userlost",
		component: userlost,
		meta: {
			requiresAuth: true,
			keepAlive: true, // 不需要被缓存
			title: "个人违规扣款"
		}
	},
	{
		name: "salaryallsum",
		path: "/salaryallsum",
		component: salaryallsum,
		meta: {
			requiresAuth: true,
			keepAlive: true, // 不需要被缓存
			title: "工资单汇总"
		}
	},
]